import { Image, Label, UIText1, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import { NewbuildingPromoBlackFridayBadge } from 'shared/components/NewbuildingPromoBlackFridayBadge';

import * as styles from './MortgageOfferRow.css';
import { GetOnlineButton } from '../GetOnlineButton';

export interface IMortgageOfferRowProps {
  interestRate: string;
  isBlackFriday: boolean;
  maxCredit: string;
  maxLoanTerm: string;
  monthlyPayment: string;
  mortgagePartnerLink?: string | null;
  onClick?: () => void;
  onGetOnlineClick?: () => void;
  onHover?: () => void;
  promoName: string;
  providerLogoUrl: string;
  providerName: string;
}

export const MortgageOfferRow: React.FC<IMortgageOfferRowProps> = ({
  interestRate,
  isBlackFriday,
  maxCredit,
  maxLoanTerm,
  monthlyPayment,
  mortgagePartnerLink,
  onClick,
  onGetOnlineClick,
  onHover,
  promoName,
  providerLogoUrl,
  providerName,
}) => {
  const handleGetOnlineClick = React.useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();

      if (onGetOnlineClick) {
        onGetOnlineClick();
      }
    },
    [onGetOnlineClick],
  );

  return (
    <div
      className={styles['row']}
      onClick={onClick}
      onMouseEnter={onHover}
      tabIndex={0}
      role="button"
      data-testid="MortgageOfferRow"
    >
      <div className={styles['main']}>
        <div className={styles['image']}>
          <Image objectFit="contain" src={providerLogoUrl} height={40} width={40} borderRadius={'50%'} />
          {isBlackFriday && (
            <div className={styles['black-friday-badge']}>
              <NewbuildingPromoBlackFridayBadge size={18} />
            </div>
          )}
        </div>
        <div className={styles['main-content']}>
          <div className={styles['promo-name']}>
            <UIText1>
              <span className={styles['no-wrap-text']}>{promoName}</span>
            </UIText1>
          </div>
          <UIText2 color="gray_icons_100">{providerName}</UIText2>
        </div>
      </div>

      <div className={styles['info']}>
        <span className={styles['rate']}>
          <UIText1>{interestRate}</UIText1>
        </span>
        <span className={styles['sum']}>
          <UIText1>{maxCredit}</UIText1>
        </span>
        <span className={styles['term']}>
          <UIText1>{maxLoanTerm}</UIText1>
        </span>
        <span className={styles['payment']}>
          <UIText1 textAlign="right">{monthlyPayment}</UIText1>
          {isBlackFriday ? (
            <div className={styles['label-wrapper']} data-testid="MortgageOfferBlackFridayLabel">
              <Label background="primary_10" color="primary_100">
                Чёрная пятница
              </Label>
            </div>
          ) : mortgagePartnerLink ? (
            <div className={styles['get-online-button']}>
              <GetOnlineButton href={mortgagePartnerLink} onClick={handleGetOnlineClick} />
            </div>
          ) : null}
        </span>
      </div>
    </div>
  );
};
